import { api, apis } from 'api';
import { contact4ui, contactFormToParams } from './util';
import { SearchGroupKey } from '@web-common/utils/contact_util';
import { transContactSearch2ContactItem, transContactModel2ContactItem } from '@web-common/components/util/contact';
export const contactApi = api.requireLogicalApi(apis.contactApiImpl);
export const accountApi = api.requireLogicalApi(apis.accountApiImpl);
export const fileApi = api.getFileApi();
export const eventApi = api.getEventApi();
export const systemApi = api.getSystemApi();
const tag = '[contact.tsx]';
export const syncAll = async (force) => {
    const orgData = await contactApi.syncAllAccount(force);
    return orgData;
};
export const getOrgs = async (params = {}) => {
    const orgData = await contactApi.doGetContactOrg(params);
    return orgData;
};
export const getPersonalOrgList = async (_account) => {
    console.log(tag, 'getPersonalOrgList params', _account);
    const { success, data } = await contactApi.doGetPersonalOrg({ _account });
    console.log(tag, 'getPersonalOrgList params result', _account, data);
    if (success && data) {
        return data;
    }
    else {
        return [];
    }
};
export const getContact = async ({ orgId = '', _account = '' }) => {
    console.log(tag, 'getContact params', _account);
    const list = await contactApi.doGetContactByOrgId({ orgId, _account });
    console.log(tag, 'getContact params result', _account, list);
    const itemList = [];
    list.forEach(item => {
        itemList.push(transContactModel2ContactItem(item));
    });
    return itemList;
};
export const getPersonContact = async (_account) => {
    console.log(tag, 'getPersonContact params', _account);
    const data = await contactApi.doGetPersonalContact({ _account });
    console.warn(tag, 'getPersonContact result', data);
    return contact4ui(data, !0);
};
const FetchLock = {
    accounts: new Map(),
    setFetchId(_account) {
        let count = FetchLock.accounts.get(_account) || 0;
        FetchLock.accounts.set(_account, ++count);
        return count;
    },
    getFetchId(_account) {
        return FetchLock.accounts.get(_account) || 0;
    },
};
const getAccountMap = async () => {
    try {
        const list = await accountApi.getMainAndSubAccounts();
        if ((list === null || list === void 0 ? void 0 : list.length) > 1) {
            return list.reduce((res, cur) => {
                if (cur.id && cur.agentEmail) {
                    res[cur.id] = cur.agentEmail;
                }
                return res;
            }, {});
        }
    }
    catch (err) {
        console.error('[contact tree] getMainAndSubAccounts error', err);
    }
    return {};
};
export const getSearchContactAddressBook = async (searchValue, callback) => {
    if (!searchValue) {
        callback(null);
        return;
    }
    const t1 = Date.now();
    contactApi.doSearchNew({
        query: searchValue,
        showDisable: false,
        useEdmData: false,
        exclude: ['orgName', 'orgPYName'],
    }, async (result) => {
        const aliasMap = await getAccountMap();
        const lxData = result.main;
        const res = {};
        Object.keys(lxData).forEach(accountName => {
            var _a;
            const item = lxData[accountName];
            if ((_a = item === null || item === void 0 ? void 0 : item.contactList) === null || _a === void 0 ? void 0 : _a.length) {
                const enterpriseList = [];
                const personalList = [];
                const allList = [];
                item.contactList.forEach(item => {
                    const contactItem = transContactSearch2ContactItem(item);
                    allList.push(contactItem);
                    if (contactItem.type === 'enterprise') {
                        enterpriseList.push(contactItem);
                    }
                    if (contactItem.type === 'personal') {
                        personalList.push(contactItem);
                    }
                });
                const account = aliasMap[accountName] || accountName;
                res[account] = {
                    [SearchGroupKey.ALL]: allList,
                    [SearchGroupKey.CORP]: enterpriseList,
                    [SearchGroupKey.PERSON]: personalList,
                    [SearchGroupKey.TEAM]: [],
                };
            }
        });
        callback(res);
        console.log(`AddressBook Search ${searchValue} in ${Date.now() - t1}ms`, res);
    });
};
export const delContact = async (contact) => {
    const { success } = await contactApi.doDeleteContact({
        accountIdList: [contact.contact.id],
    });
    return success;
};
export const editContact = async (contact, values) => {
    await contactApi.doUpdateContact(Object.assign({ accountId: contact.contact.id }, contactFormToParams(values)));
    const res = await getPersonContact();
    return res;
};
export const createContact = async (values) => {
    const res = await contactApi.doInsertContact({
        list: contactFormToParams(values),
    });
    const list = await getPersonContact();
    return {
        list,
        contact: res.data && res.data[0],
    };
};
